export const UNIWEB_API_PROXY_ROUTES = {
  QWAC: '/uniweb-api/certificate',
  QSEAL: '/uniweb-api/qseal'
};
